// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__2zqDw","ScrollX":"Scroll_ScrollX__2rmws","ScrollY":"Scroll_ScrollY__2uHft"};